// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const orderDrawerWidth =1000;
export const dataDrawerWidth =400;
export const appDrawerWidth = 320;
